const Admin = () => import(/* webpackChunkName: "proj" */ './Admin');
const Appl = () => import(/* webpackChunkName: "proj" */ './Appl');

export default {
  routes: [
    {
      path: '/proc/privt2020/admin',
      name: 'proc_privt2020_admin',
      component: Admin,
      meta:{public:true}
    },
    {
      path: '/proc/privt2020/appl',
      name: 'proc_privt2020_appl',
      component: Appl,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/proc/privt2020/router.js